/**
 *
 * CardWidget
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"

function CardWidget(props) {
  return (
    <div className="CardWidgetComponent" style={{ ...props.style }}>
      <div className="CardWidgetComponent-header">
        <span>{props.title}</span>
        {props.count && <span className="color-gray-low">{props.count}</span>}
      </div>
      <div className="CardWidgetComponent-content">{props.children}</div>
    </div>
  )
}

CardWidget.propTypes = {}

export default CardWidget
